import { useMutation, useQueryClient } from '@tanstack/react-query'
import { editRequirementQuestion } from 'api/requirements/editRequirementQuestion'
import { requirementKeys } from './keys'

type Response = Awaited<ReturnType<typeof editRequirementQuestion>>
type Variables = Omit<
  Parameters<typeof editRequirementQuestion>[0],
  'requirementId'
>

export const useEditRequirementQuestionMutation = (requirementId: number) => {
  const queryClient = useQueryClient()

  return useMutation<Response, Error, Variables>({
    mutationFn: (data) =>
      editRequirementQuestion({
        requirementId,
        ...data,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: requirementKeys.detail(requirementId),
      })
    },
  })
}
